export enum AdditionalAreaType {
    BALCONY = 1,
    LOGGIA = 2,
    TERRACE = 3,
    GARDEN = 4
}

export const additionalAreaNames = {
    [AdditionalAreaType.BALCONY]: "balkon",
    [AdditionalAreaType.LOGGIA]: "loggia",
    [AdditionalAreaType.TERRACE]: "taras",
    [AdditionalAreaType.GARDEN]: "ogródek"
};

export const getAdditionalAreaName = (type: AdditionalAreaType) => {
    switch (type) {
        case AdditionalAreaType.BALCONY:
            return "balkon";
        case AdditionalAreaType.LOGGIA:
            return "loggia";
        case AdditionalAreaType.TERRACE:
            return "taras";
        case AdditionalAreaType.GARDEN:
            return "ogródek";
        default:
            return "";
    }
};

export const getAdditionalAreaType = (name: string) => {
    switch (name) {
        case "balkon":
            return AdditionalAreaType.BALCONY;
        case "loggia":
            return AdditionalAreaType.LOGGIA;
        case "taras":
            return AdditionalAreaType.TERRACE;
        case "ogródek":
            return AdditionalAreaType.GARDEN;
        default:
            return null;
    }
};
export enum AdditionalAreaType {
    BALCONY = 1,
    LOGGIA = 2,
    TERRACE = 3,
    GARDEN = 4
}

export const additionalAreaNames = {
    [AdditionalAreaType.BALCONY]: "balkon",
    [AdditionalAreaType.LOGGIA]: "loggia",
    [AdditionalAreaType.TERRACE]: "taras",
    [AdditionalAreaType.GARDEN]: "ogródek"
};

export const getAdditionalAreaName = (type: AdditionalAreaType) => {
    switch (type) {
        case AdditionalAreaType.BALCONY:
            return "balkon";
        case AdditionalAreaType.LOGGIA:
            return "loggia";
        case AdditionalAreaType.TERRACE:
            return "taras";
        case AdditionalAreaType.GARDEN:
            return "ogródek";
        default:
            return "";
    }
};

export const getAdditionalAreaType = (name: string) => {
    switch (name) {
        case "balkon":
            return AdditionalAreaType.BALCONY;
        case "loggia":
            return AdditionalAreaType.LOGGIA;
        case "taras":
            return AdditionalAreaType.TERRACE;
        case "ogródek":
            return AdditionalAreaType.GARDEN;
        default:
            return null;
    }
};
